export default __webpack_public_path__ + "static/media/IkonRisikostyring.584c8149.svg";